<script setup lang="ts">
import AutoComplate from "@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue"
import organizationType from "@/types/requests/organizationType"
import FormRow from "@/components/Common/FormRow.vue"
import { computed } from "vue"
import i18n from "@/lang/i18n"

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: organizationType | null
  organizations: organizationType[]
  windowInnerWidth: number
  errorMessages: string[]
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

</script>
<template>
  <FormRow
    :title="i18n.global.t('pages.roleAssignment.form.origanizations')"
    :windowInnerWidth="props.windowInnerWidth"
    :required="true"
  >
    <div style="width: 40%">
      <AutoComplate
        v-model="modelValue"
        :items="props.organizations"
        itemName="name"
        :errorMessages="props.errorMessages"
      />
    </div>
  </FormRow>
</template>
